export type IGetDataForViewDataModal = (
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
) => void;

export function _getDataForViewDataModal(
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
): void {
  const $triggerElm = $(triggerElm);
  const isStaticData = $triggerElm.hasClass('show-static-data-modal');
  const json = isStaticData ? {} : JSON.parse(decodeURIComponent($triggerElm.data('json')));
  // Modal Elements
  const $modal = $(modal);
  const $modalHeader = $modal.find('.modal-header');
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalLoading = $modal.find('.loading');
  const $dataContainer = $modal.find('.data-container');
  const { dataLoadUlr, modalTitle } = json;
  let { modalContent = '' } = json;

  if (isStaticData) {
    $modalHeader.addClass('hide');
    modalContent = $($triggerElm.attr('href') as string).html();
  }

  $triggerElm.tooltip('hide');
  const getContent = () =>
    dataLoadUlr ? $.get(dataLoadUlr) : new ($ as any).Deferred().resolve(modalContent);

  // Grab info from data-modal-title inside the a tag, to place in the modal title
  $modalTitle.text(modalTitle);

  getContent().done((responseData: HTMLElement) => {
    $modalLoading.addClass('hide').attr('aria-hidden', 'true');
    $dataContainer.removeClass('hide').attr('aria-hidden', 'false').append(responseData);
  });
}
